module.exports = __webpack_public_path__ + "dingbeauty/admin/img/card_icon_visa.86cd88a3.svg";